/**
 * Shared "Section header" inspector panel for premium blocks.
 *
 * @package
 * @since   3.5.0
 */

import { __ } from '@wordpress/i18n';
import {
	PanelBody,
	ToggleControl,
	TextControl,
	TextareaControl,
	SelectControl,
} from '@wordpress/components';

const ALIGN_OPTIONS = [
	{ label: __( 'Left', 'havenlytics' ), value: 'left' },
	{ label: __( 'Center', 'havenlytics' ), value: 'center' },
	{ label: __( 'Right', 'havenlytics' ), value: 'right' },
];

const TARGET_OPTIONS = [
	{ label: __( 'Same tab', 'havenlytics' ), value: '_self' },
	{ label: __( 'New tab', 'havenlytics' ), value: '_blank' },
];

export default function SectionHeaderPanel( { attributes, setAttributes } ) {
	const {
		showHeader,
		sectionSubtitle,
		sectionTitle,
		sectionDescription,
		sectionAlign,
		sectionButtonShow,
		sectionButtonText,
		sectionButtonUrl,
		sectionButtonTarget,
	} = attributes;

	return (
		<PanelBody
			title={ __( 'Section header', 'havenlytics' ) }
			initialOpen={ false }
		>
			<p className="components-base-control__help">
				{ __(
					'Optional heading above the listings. Leave empty fields blank to hide them.',
					'havenlytics'
				) }
			</p>
			<ToggleControl
				label={ __( 'Show header', 'havenlytics' ) }
				checked={ showHeader !== false }
				onChange={ ( value ) => setAttributes( { showHeader: value } ) }
				__nextHasNoMarginBottom
			/>
			{ showHeader !== false && (
				<>
					<TextControl
						label={ __( 'Subtitle', 'havenlytics' ) }
						value={ sectionSubtitle || '' }
						placeholder={ __( 'Optional eyebrow', 'havenlytics' ) }
						onChange={ ( value ) =>
							setAttributes( { sectionSubtitle: value } )
						}
						__nextHasNoMarginBottom
					/>
					<TextControl
						label={ __( 'Title', 'havenlytics' ) }
						value={ sectionTitle || '' }
						onChange={ ( value ) =>
							setAttributes( { sectionTitle: value } )
						}
						__nextHasNoMarginBottom
					/>
					<TextareaControl
						label={ __( 'Description', 'havenlytics' ) }
						value={ sectionDescription || '' }
						rows={ 3 }
						onChange={ ( value ) =>
							setAttributes( { sectionDescription: value } )
						}
						__nextHasNoMarginBottom
					/>
					<SelectControl
						label={ __( 'Alignment', 'havenlytics' ) }
						value={ sectionAlign || 'left' }
						options={ ALIGN_OPTIONS }
						onChange={ ( value ) =>
							setAttributes( { sectionAlign: value } )
						}
						__nextHasNoMarginBottom
					/>
					<ToggleControl
						label={ __( 'Show button', 'havenlytics' ) }
						checked={ !! sectionButtonShow }
						onChange={ ( value ) =>
							setAttributes( { sectionButtonShow: value } )
						}
						__nextHasNoMarginBottom
					/>
					{ !! sectionButtonShow && (
						<>
							<TextControl
								label={ __( 'Button text', 'havenlytics' ) }
								value={ sectionButtonText || '' }
								onChange={ ( value ) =>
									setAttributes( {
										sectionButtonText: value,
									} )
								}
								__nextHasNoMarginBottom
							/>
							<TextControl
								label={ __( 'Button URL', 'havenlytics' ) }
								value={ sectionButtonUrl || '' }
								onChange={ ( value ) =>
									setAttributes( {
										sectionButtonUrl: value,
									} )
								}
								type="url"
								__nextHasNoMarginBottom
							/>
							<SelectControl
								label={ __( 'Open link in', 'havenlytics' ) }
								value={ sectionButtonTarget || '_self' }
								options={ TARGET_OPTIONS }
								onChange={ ( value ) =>
									setAttributes( {
										sectionButtonTarget: value,
									} )
								}
								__nextHasNoMarginBottom
							/>
						</>
					) }
				</>
			) }
		</PanelBody>
	);
}
